import HTTP_GESCOM from '../HTTP_GESCOM';

const URL_BASE = 'gescom/Devis/';

export async function getAsync(id) {
  const response = await HTTP_GESCOM.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function brouillon2Enregistre(id) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'Brouillon2Enregistre', { id: id });
  return response;
}

export async function createAsync(payload) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'CreateAsync', payload);
  return response;
}

export async function updateAsync(payload) {
  const response = await HTTP_GESCOM.put(URL_BASE + 'UpdateAsync', payload);
  return response;
}

export async function getAll(serverTabledata) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'PGetAllAsync', serverTabledata);
  return response;
}

export async function sansSuite(id) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'SansSuiteAsync', { id: id });
  return response;
}

export async function setAfficherSurPortail(ids, afficherSurPortail) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'SetAfficherSurPortailAsync', { ids, afficherSurPortail });
  return response;
}

export async function buildLinkPortail(idClient, typeClient) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'BuildLienPortailClientAsync', { idClient, typeClient });
  return response;
}
